<template>
  <div class="flex flex-col justify-center h-full leading-tight" :title="tooltipText">
    <span v-if="payerName" class="sensitive text-sm text-gray-900 font-semibold truncate">{{ payerName }}</span>
    <span v-if="contractType" class="text-xs truncate">
      <span class="inline px-1 py-0.5 bg-purple-50 text-purple-700 rounded font-medium">{{ contractType }}</span>
    </span>
    <span v-if="contractName" class="sensitive text-xs text-gray-600 truncate">{{ contractName }}</span>
    <span v-if="contractState" class="text-xs text-gray-500 truncate">{{ contractState }}</span>
  </div>
</template>

<script>
export default {
  name: 'PayerCompositeRenderer',
  props: ['params'],
  computed: {
    payerName() {
      return this.params.data?.metadata?.payer_name || this.params.data?.payer_name;
    },
    contractType() {
      return this.params.data?.metadata?.contract_type || this.params.data?.contract_type;
    },
    contractName() {
      return this.params.data?.metadata?.contract_name || this.params.data?.contract_name;
    },
    contractState() {
      return this.params.data?.metadata?.contract_state || this.params.data?.contract_state;
    },
    tooltipText() {
      return [this.payerName, this.contractType, this.contractName, this.contractState].filter(Boolean).join(' — ');
    }
  }
}
</script>
